import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const caasPlugin = createPlugin({
  id: 'caas',
  routes: {
    root: rootRouteRef,
  },
});

export const CaasPage = caasPlugin.provide(
  createRoutableExtension({
    name: 'CaasPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
